import { render, staticRenderFns } from "./CoursesNotAvailable.vue?vue&type=template&id=0519704a&scoped=true"
import script from "./CoursesNotAvailable.vue?vue&type=script&lang=js"
export * from "./CoursesNotAvailable.vue?vue&type=script&lang=js"
import style0 from "./CoursesNotAvailable.vue?vue&type=style&index=0&id=0519704a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0519704a",
  null
  
)

export default component.exports